import { Common } from '@stockbit/ui';
import PropTypes from 'prop-types';

import { TradingMenuItemContainer } from './styled';

const { Iconmoon, IconWrapper, Text } = Common;

const TradingMenuItem = ({ iconmoon, children, ...otherProps }) => (
  <TradingMenuItemContainer {...otherProps}>
    <IconWrapper size="14px">
      <Iconmoon size="12px" className={iconmoon} />
    </IconWrapper>
    <Text size="14px" height="28px" padding="0 8px">
      {children}
    </Text>
  </TradingMenuItemContainer>
);

TradingMenuItem.propTypes = {
  iconmoon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TradingMenuItem;
